export default __webpack_public_path__ + "static/media/car04.edfb2d41.jpg";